const villa_initial = (payload) => {
  return {
    type: "villaInitial",
    payload,
  };
};

export default villa_initial;
